module.exports = __webpack_public_path__ + "static/img/webpc.cfb2b46.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/webpc.gif
// module id = ++De
// module chunks = 1